/* eslint-disable max-len */
import type { IconPrimitiveProps } from 'types';

const IconGift = (props: IconPrimitiveProps) => {
  const {
    size = 24,
    ...rest
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      viewBox="0 0 24 24"
      width={size}
      height={size}
      {...rest}
    >
      <path strokeMiterlimit={10} d="M18.712 10.399H5.238v6.4c0 2.4.842 3.201 3.368 3.201h6.737c2.526 0 3.369-.8 3.369-3.2v-6.401ZM20 7.999v.8c0 .88-.446 1.6-1.684 1.6H5.684c-1.288 0-1.684-.72-1.684-1.6v-.8c0-.88.396-1.6 1.684-1.6h12.632c1.238 0 1.684.72 1.684 1.6Zm-8.303-1.6H7.048a.728.728 0 0 1-.208-.526.732.732 0 0 1 .234-.515l1.195-1.136A.83.83 0 0 1 8.838 4a.83.83 0 0 1 .568.222l2.29 2.176Zm5.246 0h-4.648l2.29-2.177A.83.83 0 0 1 15.154 4a.83.83 0 0 1 .568.222l1.196 1.136a.723.723 0 0 1 .025 1.04v0Z" />
      <path strokeMiterlimit={10} d="M9.423 10.399v4.112c0 .64.74 1.016 1.305.672l.791-.496a.874.874 0 0 1 .927 0l.75.48a.869.869 0 0 0 .861.04.822.822 0 0 0 .324-.294.768.768 0 0 0 .12-.41V10.4H9.422Z" />
    </svg>
  );
};
export default IconGift;
